<template>
  <div class="search-input">
    <div class="search-input__field">
      <label
        for="search"
        class="search-input__label"
      >
        <slot name="search" />
      </label>
      <input
        id="search"
        :value="value"
        type="text"
        :placeholder="placeholder"
        class="search-input__input"
        @keyup="keyup"
        @input="updateValue"
      >
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'search-input',
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
  emits: ['keyup', 'update:modelValue'],
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value)
    },
    keyup(event) {
      this.$emit('keyup', event)
    },
  },
}
</script>

<style lang="scss">
.search-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @include screen-size(lg) {
    display: grid;
    grid-template-columns: 89% 10%;
    align-items: end;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__label {
    font-size: 0.875rem;
    line-height: 1rem;
    color: $neutral-01;
    font-weight: 600;
  }

  &__input {
    font-family: "Montserrat", sans-serif;
    outline: none;

    appearance: none;
    width: 100%;
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: -0.016rem;
    line-height: 1.875rem;
    padding: 0.75rem 1rem;
    border: 0.125rem solid $neutral-04;
    margin-bottom: 0.813rem;

    &:placeholder {
      color: $neutral-02;
    }

    @include screen-size(lg) {
      height: 3.125rem;
      padding: 0.75rem 1.25rem;
      margin-bottom: unset;
    }
  }
}
</style>
